"use strict";
// (C) 2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPEAT_EXECUTE_ON = exports.FREQUENCY_TYPE = exports.REPEAT_FREQUENCIES = exports.REPEAT_TYPES = exports.DEFAULT_REPEAT_PERIOD = exports.DEFAULT_DROPDOWN_ZINDEX = exports.DEFAULT_DROPDOWN_ALIGN_POINTS = exports.PLATFORM_DATE_FORMAT = exports.DASHBOARD_TITLE_MAX_LENGTH = void 0;
exports.DASHBOARD_TITLE_MAX_LENGTH = 255;
exports.PLATFORM_DATE_FORMAT = "yyyy-MM-dd";
exports.DEFAULT_DROPDOWN_ALIGN_POINTS = [
    {
        align: "bl tl",
    },
    {
        align: "tl bl",
    },
];
exports.DEFAULT_DROPDOWN_ZINDEX = 5001;
exports.DEFAULT_REPEAT_PERIOD = 1;
exports.REPEAT_TYPES = {
    WEEKLY: "weekly",
    DAILY: "daily",
    MONTHLY: "monthly",
    CUSTOM: "custom",
};
exports.REPEAT_FREQUENCIES = {
    DAY: "day",
    MONTH: "month",
    WEEK: "week",
};
exports.FREQUENCY_TYPE = [exports.REPEAT_FREQUENCIES.DAY, exports.REPEAT_FREQUENCIES.WEEK, exports.REPEAT_FREQUENCIES.MONTH];
exports.REPEAT_EXECUTE_ON = {
    DAY_OF_MONTH: "dayOfMonth",
    DAY_OF_WEEK: "dayOfWeek",
};
//# sourceMappingURL=constants.js.map